import {cNoteSide, CNoteSide} from "./cnote-side/ContractNoteSidePipe";
import {contractNoteStatusPipe, ContractNoteStatusPipe} from "./cnote-status/ContractNoteStatusPipe";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.pipes`;

    return angular.module(moduleName, [])
                  .filter(CNoteSide, cNoteSide)
                  .filter(ContractNoteStatusPipe, contractNoteStatusPipe)
                  .name;
}
